export default "__VITE_ASSET__Ccj6Q9MC__"